import { createMultiplayer } from '../multiplayer/runtime';
import { separateMultiplayerEntry } from './multiplayerSpawn';
import type { Runtime } from './runtime';
import type { UrlOptions } from './types';

export function connectCitySession(rt: Runtime): void {
  if (rt.gameMode === 'multi') {
    rt.network = createMultiplayer(
      rt.init,
      rt.time,
      () => rt.control.controlState,
      (value) => {
        rt.hud.setConnection(`${rt.name} · ${value}`);
      },
      { character: rt.character, name: rt.name, clothing: rt.clothing },
      () => rt.visitorView.names.visible,
      (players) => {
        rt.control.controlState = separateMultiplayerEntry(
          rt.control.controlState,
          rt.env.env,
          players.map((player) => [player.x, -player.z])
        );
      },
      () => {
        void rt.account.refresh();
      }
    );
  } else rt.hud.setConnection(`${rt.name} · Exploring on your own`);
}

/** Walking alone, under the visitor's own options and clock, as before the shared city. */
export function exploreAlone(rt: Runtime, options: UrlOptions): void {
  rt.network?.dispose();
  rt.network = null;
  rt.gameMode = 'single';
  if (!rt.time.editable) rt.time.unlock();
  rt.options = options;
  rt.env.env = rt.init.env;
}

/** Signing out an account ends its presence; a guest's account refresh must keep them connected. */
export function leaveSharedCityWhenSignedOut(rt: Runtime, options: UrlOptions): () => void {
  let signedIn = rt.account.state.kind === 'signedIn';
  return rt.account.onChange((state) => {
    const wasSignedIn = signedIn;
    signedIn = state.kind === 'signedIn';
    if (signedIn || !wasSignedIn || rt.gameMode !== 'multi') return;
    exploreAlone(rt, options);
    connectCitySession(rt);
  });
}
